<template>
  <colored-lemmas v-if="appStep === states.ONGOING_SESSION && (currentComponent === 'vocabularyCardWord' || displayWord) && currentWord != null "
      id="subtitles" :key="currentWord.lemma.id"
                  :sentence="coloredSubtitles.join(' ')"
                  :lemma="currentWord.lemma.english"
                  :type="currentWord.lemma.word_type"
                  color="#59daff">
  </colored-lemmas>
  <!--<div id="subtitles" class="flexwrap centercenter">
    <span class="line-clamp clamp3">{{currentWord.first_sentence.sentence}}</span>

    <span v-for="(word, index) in coloredSubtitles" :key="index">
              <span :class="{originalWord : isOriginalWord(word)}">{{ word }}&thinsp;</span>
          </span>
  </div>-->
</template>

<script>
import {mapGetters} from 'vuex'

export default {
  name: "subtitles",

  components: {
    coloredLemmas: () => import(/* webpackPrefetch: true */ '@/components/coloredLemmas.vue')
  },

  computed: {
    ...mapGetters('global', [
        'isMobile',
      'appStep',
        'states'
    ]),
    ...mapGetters('session', [
      'currentWord',
        'currentComponent',
        'displayWord'
    ]),

    coloredSubtitles: function () {
      let sentence = this.currentWord.first_sentence.sentence.trim();
      let firstchar = sentence.charAt(0);
      if (firstchar !== firstchar.toUpperCase()) {
        sentence = "... " + sentence;
      }
      let laststchar = sentence.charAt(sentence.length - 1);
      if (!laststchar.match(/^[.!?]/)) {
        sentence = sentence + " ...";
      }
      // On définit un nombre de character maximum pour la phrase contextuelle.
      // Si la phrase contextuelle dépasse le nombre de character on applique l'algorithme suivant
      return this.centerLemma(this.maxChars, sentence);
    },
  },

  methods: {
    centerLemma: function (max_char, sentence) {
      /* On parcourt sentence, mot à mot et on récupère le mot si sa distance au lemme est la plus faible depuis le début */
      // On crée le tableau des mots de sentence
      let wordTabs = sentence.split(/[^A-Za-z^-]/);
      // On crée un tableau des lemmes
      let lemmas = this.currentWord.lemma.english.split(' ');
      // On crée un tableau des futures objects correspondants à un lemme et sa position
      let originalWords = [];
      for (let i = 0; i < lemmas.length; i++) {
        let wordData = {
          word: wordTabs[0],
          pos: 0
        };
        originalWords[i] = wordData;
      }
      // boucle générale de sentence
      for (let i = 0; i < wordTabs.length; i++) {
        // On repère le mot le plus proche dans la phrase
        for (let j = 0; j < lemmas.length; j++) {
          if (this.levenshtein(originalWords[j].word, lemmas[j]) > this.levenshtein(wordTabs[i], lemmas[j])) {
            let wordData = {
              word: wordTabs[i],
              pos: i
            };
            originalWords[j] = wordData;
          }
        }
      }
      this.originalWords = originalWords;

      let posLemma = sentence.search(originalWords[0].word);
      let originalWord = sentence.substring(posLemma, (sentence.search(originalWords[originalWords.length - 1].word) + originalWords[originalWords.length - 1].word.length));
      let sentenceObject = {
        part1: sentence.slice(0, posLemma),
        originalWords: originalWord,
        part2: sentence.slice(posLemma + originalWord.length, sentence.length),
      };

      if (sentence.length > max_char) {
        let startIndex = 0;
        let part1 = '';
        let part2 = '';
        let endIndex = max_char;
        let reste = 0;
        let afterLemme = 0;
        let pre = '';
        let suf = '';

        if (posLemma - Math.floor((max_char - originalWord.length) / 2) <= 0) {
          startIndex = 0;
          endIndex = max_char;
          do {
            endIndex++;
          }
          while (sentence[endIndex] !== " " && endIndex < sentence.length)
        }

        /* S'il y a + de 75 characters avant le lemme, on décalera le startIndex vers la gauche
                  s'il y en a - de 75 à droite du lemme. */


        else {
          pre = '...';
          reste = posLemma - Math.floor((max_char - originalWord.length) / 2);
          afterLemme = sentence.length - (posLemma + originalWord.length);
          if (afterLemme > Math.floor((max_char - originalWord.length) / 2)) {
            startIndex = reste;
          } else {
            startIndex = reste - Math.floor(((max_char - originalWord.length) / 2 - afterLemme));
          }
          endIndex = startIndex + max_char;
          do {
            startIndex--;
          }
          while (sentence[startIndex] !== " " && startIndex > 0)
        }
        if (sentence.length - (posLemma + originalWord.length) > Math.floor((max_char - originalWord.length) / 2)) {
          suf = '...';
        }

        part1 = pre + sentence.slice(startIndex, posLemma);
        part2 = sentence.slice(posLemma + originalWord.length, endIndex) + suf;
        sentenceObject.part1 = part1;
        sentenceObject.part2 = part2;
      }
      let finalSentence = sentenceObject.part1 + sentenceObject.originalWords + sentenceObject.part2;

      return finalSentence.split(' ');
    },

    isOriginalWord: function (word) {
      for (let i = 0; i < this.originalWords.length; i++) {
        if (this.originalWords[i].word === word.replace(/[^a-zA-Z ]/g, "")) {
          return true;
        }
      }
      return false;
    },
    levenshtein: function (a, b) {
      if (a.length === 0) return b.length;
      if (b.length === 0) return a.length;

      var matrix = [];

      // increment along the first column of each row
      var i;
      for (i = 0; i <= b.length; i++) {
        matrix[i] = [i];
      }

      // increment each column in the first row
      var j;
      for (j = 0; j <= a.length; j++) {
        matrix[0][j] = j;
      }

      // Fill in the rest of the matrix
      for (i = 1; i <= b.length; i++) {
        for (j = 1; j <= a.length; j++) {
          if (b.charAt(i - 1) == a.charAt(j - 1)) {
            matrix[i][j] = matrix[i - 1][j - 1];
          } else {
            matrix[i][j] = Math.min(matrix[i - 1][j - 1] + 1, // substitution
                Math.min(matrix[i][j - 1] + 1, // insertion
                    matrix[i - 1][j] + 1)); // deletion
          }
        }
      }

      return matrix[b.length][a.length];
    }
  },

  data() {
    return {
      originalWords: [],
      maxChars: 100,
    }
  }
}
</script>

<style scoped>

#subtitles {
  height: auto;
  max-width: 100%;
  width: 100%;
  text-align: center;
  font-family: 'Open Sans';
  font-size: 100%;
  font-weight: bold;
  text-shadow: 0.1vw 0.1vw #000, -0.1vw -0.1vw #000, -0.1vw 0.1vw #000, 0.1vw -0.1vw #000,
  0.14vw 0px #000, -0.14vw -0px #000, -0.14vw 0px #000, 0.14vw -0px #000,
  0px 0.14vw #000, -0px -0.14vw #000, -0px 0.14vw #000, 0px -0.14vw #000;
  letter-spacing: 0.08vw;
}

.originalWord {
  color: #59daff;
}

.line-clamp {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  width: 100%;
  padding: 0.1vw;
}

.clamp3 {
  -webkit-line-clamp: 3;
}


@media screen and (max-device-width: 767px) {

  #subtitles {
    font-size: 100%;
    text-shadow: 0.3vw 0.3vw #000, -0.3vw -0.3vw #000, -0.3vw 0.3vw #000, 0.3vw -0.3vw #000,
    0.5vw 0px #000, -0.5vw -0px #000, -0.5vw 0px #000, 0.5vw -0px #000,
    0px 0.5vw #000, -0px -0.5vw #000, -0px 0.5vw #000, 0px -0.5vw #000;
    letter-spacing: 0.32vw;
  }
}


</style>